
























































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { genesisIdToNetwork } from '../utils'

@Component
export default class Frame extends Vue {
    private searchString = ''

    get routeName() { return this.$route.name }
    get isHome() { return this.routeName === 'home' }
    get price() { return this.$store.state.price }
    get isHeadReady() { return this.$store.state.chainStatus.head.number > 0 }

    get network() {
        switch (genesisIdToNetwork(this.$connex.thor.genesis.id)) {
            case 'main': return 'MainNet'
            case 'test': return 'TestNet'
            case 'solo': return 'Solo'
            case 'custom': return 'Custom'
        }
    }

    get switchableNetworks(): Array<{ name: string, href: string }> {
        switch (genesisIdToNetwork(this.$connex.thor.genesis.id)) {
            case 'main': return [{ name: 'TestNet', href: '#/test/' }]
            case 'test': return [{ name: 'MainNet', href: '#/main/' }]
            default: return [{ name: 'TestNet', href: '#/test/' }, { name: 'MainNet', href: '#/main/' }]
        }
    }

    get networkBadgeVariant() {
        return genesisIdToNetwork(this.$connex.thor.genesis.id) === 'main' ? 'light' : 'warning'
    }

    private search() {
        const str = this.searchString.trim()
        this.searchString = ''
        if (!str) {
            return
        }
        this.$router.push({ name: 'search', query: { q: str } })
    }

    get routeViewKey() {
        if (this.$route.matched.find(i => i.name === 'account')) {
            return `accounts-${this.$route.params.address.toLowerCase()}`
        }
        return this.$route.fullPath
    }

    @Watch('$route.path')
    private routed() {
        const name = this.$route.name
        const params = this.$route.params

        let subTitle
        if (this.$route.matched.find(r => r.name === 'account')) {
            subTitle = 'Account ' + this.$options.filters!.checksum(params.address)
        } else if (name === 'tx') {
            subTitle = 'Tx ' + params.id
        } else if (name === 'block') {
            subTitle = 'Block ' + params.id
        } else if (name === 'search') {
            subTitle = 'Search'
        }
        document.title = subTitle ? `Insight | ${subTitle}` : 'explore.veblocks.net'
    }
    private created() {
        this.routed()
    }
}
